import { render, staticRenderFns } from "./PSOLink.vue?vue&type=template&id=3bfa8693&scoped=true&"
import script from "./PSOLink.vue?vue&type=script&lang=ts&"
export * from "./PSOLink.vue?vue&type=script&lang=ts&"
import style0 from "./PSOLink.vue?vue&type=style&index=0&id=3bfa8693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa8693",
  null
  
)

export default component.exports